if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (document.querySelector('cart-drawer')) {
        document.querySelectorAll('.single-add-to-cart-button').forEach(btn =>
          btn.setAttribute('aria-haspopup', 'dialog')
        );
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      this.handleErrorMessage();

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });
  
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      try {
        const fetchResponse = await fetch(`${routes.cart_add_url}`, config);
        const response = await fetchResponse.json();
        
        if (response.status) {
          const translatedDescription = window.translateShopifyCartMessage
            ? window.translateShopifyCartMessage(response.description)
            : response.description;
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || translatedDescription,
            message: response.message,
          });
          this.handleErrorMessage(translatedDescription);

          const soldOutMessage = submitButtons[0]?.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          submitButtons.forEach(btn => btn.setAttribute('aria-disabled', true));
          submitButtons.forEach(btn => btn.querySelector('span')?.classList.add('hidden'));
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          // Check and update cart discount before rendering contents
          const sectionsToUpdate = this.cart.getSectionsToRender().map(s => s.id);
          const updatedSections = await checkAndUpdateCartDiscount(
            sectionsToUpdate.join(',')
          );
          
          if (updatedSections) {
            response.sections = updatedSections;
          }
          
          this.cart.renderContents(response);
        }
      } catch (e) {
        console.error(e);
      } finally {
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
        submitButtons.forEach((submitButton) => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });

        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}